import fontStyles from 'styles/Fonts.module.scss';
import PropTypes from 'prop-types';
import styles from 'styles/Title.module.scss';
import toNewline from 'utils/to-newline';
import { useMemo } from 'react';
import variables from 'styles/variables.module.scss';

const Title = ({
    content,
    align = false,
    alignText = false,
    colored = false,
    titleType = 'title',
    width = '100%',
    preTitle = null,
    verifyNewLine = false,
    extraProps = {},
    tag = 'p',
    marginBottom = '40px',
    isWhite = false
}) => {
    const Tag = tag;
    const displayContentTitle = useMemo(() => toNewline(content), [content]);

    let displayContentPreTitle = null;
    if (preTitle !== null) {
        displayContentPreTitle = useMemo(() => toNewline(preTitle), [preTitle]);
    };

    return (

        <div
            className={
                align ? styles.title_container_center : styles.title_container
            }
            style={{ marginBottom }}
        >
            {preTitle && <span className={fontStyles.text_header5} {...extraProps}>{verifyNewLine ? preTitle : displayContentPreTitle}</span>}

            <Tag
                style={{ color: isWhite ? variables.whiteColor : (colored ? variables.primaryColor : variables.textColor), maxWidth: width }}
                className={`
                    ${titleType === 'title' ? styles.title : ''}
                    ${titleType === 'subtitle' ? styles.subtitle : ''}
                    ${titleType === 'small-title' ? styles.smallTitle : ''}

                    ${titleType === 'title' ? fontStyles.text_header2 : ''}
                    ${titleType === 'subtitle' ? fontStyles.text_header4 : ''}
                    ${titleType === 'small-title' ? fontStyles.text_normal_xl : ''}
                    ${alignText ? styles.alignText : ''}
                `}
                {...extraProps}
            >
                {verifyNewLine ? content : displayContentTitle}
            </Tag>
        </div>
    );
};

Title.propTypes = {
    content: PropTypes.string.isRequired,
    align: PropTypes.bool,
    alignText: PropTypes.bool,
    colored: PropTypes.bool,
    titleType: PropTypes.oneOf(['title', 'subtitle', 'small-title']),
    width: PropTypes.string,
    preTitle: PropTypes.string,
    verifyNewLine: PropTypes.bool,
    extraProps: PropTypes.object,
    tag: PropTypes.string,
    marginBottom: PropTypes.string,
    isWhite: PropTypes.bool
};

export default Title;
